import increaseColorPointByStep from '../../../../../common/utils/increase-color-point-by-step';

const light = (params) => {
  const { targetColor, targetColorPalette } = params;
  if (targetColor.equals(targetColorPalette[900])) {
    return targetColor;
  }

  return increaseColorPointByStep({
    targetColor,
    targetColorPalette,
    step: 1,
    fallback: {
      rule: 'checkbox.switchedOff.background.light',
      params,
    },
  });
};

export default light;
